import { SetLog, TagLogs } from "../../../logs/set-log";

export async function pipeRequest({
  query, config
}) {
  const response = await fetch(config?.pipeUrl, {
    //HTTP Request
    method: 'POST',
    headers: {
      accept: 'application/json',
      'Authorization': `Bearer ${config?.pipeToken}`,
      'Content-type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify({ query: query }),

  });

  let json;
  try {
    json = await response.json();

    if (json?.errors && json.errors.length > 0) {
      SetLog(TagLogs.error_details_dispath_hook_update, { data: { query: query, error: json } }, false)
    }
    // console.log({ ...json }, 'response')
  } catch (err) {
    console.log(err.message, 'aaa');
    SetLog(TagLogs.error_query_dispath_hook_update, { data: {query: query, error: err.message} }, false);
  }

  return json;
}